type Props = {
  onChange: (e: any) => void;
  defaultValue: string;
  children: any;
};

const CustomSelect = (props: Props) => {
  return (
    <select
      onChange={props.onChange}
      defaultValue={props.defaultValue}
      className="text-md hover:ring-2 block w-full rounded-md border-0 p-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset"
    >
      {props.children}
    </select>
  );
};

export default CustomSelect;
